import React, { createContext, useContext } from 'react';
import { useNotifications } from '../hooks/useNotifications';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const notifications = useNotifications();
  return (
    <NotificationContext.Provider value={notifications}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationState = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    return { notifications: [], unreadCount: 0, isConnected: false, clearNotifications: () => {}, markAsRead: () => {} };
  }
  return context;
};
